import React from 'react'
import { sampleProducts } from '../lib/FakeData'
import ProductCard from './ProductCard3'
import { useSelector } from 'react-redux';

export const GridProducts = () => {
  const productList = useSelector((state) => state.productList);
    const { loading, error, products } = productList;
  return (
    <div className='w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 items-center justify-center relative gap-2'>
          {products &&  products.slice(0,9)?.map((value, index) => {
           return <ProductCard key={index} product={value}/>
          })}
    </div>
  )
}
